<template>
  <div>Auth0 Callback!</div>
</template>
